module.exports = __webpack_public_path__ + "static/media/file-unsharing.a00c6843.svg";